import React from 'react';
import { useTranslate } from '@hooks';
import { Row, Col, FormGroup, Label } from 'reactstrap';
import { FormFilter as Form, CreativeStatusSelect, LocaleSelect } from '@dotone/react-ui-core';
import { OfferSearchInput } from '../forms';

const TextCreativeFilterForm = (props) => {
  const { t } = useTranslate('textCreative', 'model');

  return (
    <Form {...props}>
      <Row>
        <Col md={6} lg={4} xl={3}>
          <FormGroup>
            <Label>{t('offer')}</Label>
            <OfferSearchInput multi name="offerIds" />
          </FormGroup>
        </Col>
        <Col md={6} lg={4} xl={3}>
          <FormGroup>
            <Label>{t('status')}</Label>
            <CreativeStatusSelect variant="filter" multi name="statuses" />
          </FormGroup>
        </Col>
        <Col md={6} lg={4} xl={3}>
          <FormGroup>
            <Label>{t('locales')}</Label>
            <LocaleSelect name="creativeLocales" multi />
          </FormGroup>
        </Col>
      </Row>
    </Form>
  );
};

export default TextCreativeFilterForm;
